import { api } from '../api';
import { IUsers } from '../../types/user.interface';

export interface IIsuGroupStat { name: string; count: number }

export const isuGroupApi = api.injectEndpoints({
  endpoints: builder => ({
    getIsuGroups: builder.query<IIsuGroupStat[], void>({
      query: () => `/users/isu-groups`,
      providesTags: ['User'],
    }),
    renameIsuGroup: builder.mutation<void, { from: string; to: string }>({
      query: ({ from, to }) => ({ url: `/users/isu-groups/rename`, method: 'PUT', params: { from, to } }),
      invalidatesTags: ['User'],
    }),
    getUsersByIsuGroup: builder.query<IUsers, { name: string; pageNumber: number; pageSize: number }>({
      query: ({ name, pageNumber, pageSize }) => ({ url: `/users/search`, params: { isuGroup: name, isuGroupExact: true, pageNumber, pageSize } }),
      providesTags: ['User'],
    }),
    deleteIsuGroup: builder.mutation<void, { name: string; removeUsers?: boolean }>({
      query: ({ name, removeUsers = false }) => ({ url: `/users/isu-groups`, method: 'DELETE', params: { name, removeUsers } }),
      invalidatesTags: ['User'],
    }),
  }),
});


